<template>
  <div class="layer">
    <div class="inner" :data-duplicate="createType === 'duplicate'">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{locale.create_shop}}</h2>
      <!-- 생성타입 선택 -->
      <div v-if="canDuplicate && !createType">
        <div class="createBtns">
          <button type="button" class="btnCreate btnDup" @click="setCreateType('duplicate')">
            {{ locale.shop_duplicate }}
          </button>
          <button type="button" class="btnCreate btnNew" @click="setCreateType('new')">
            {{ locale.create_new }}
          </button>
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        </div>
      </div>
      <!-- //생성타입 선택 -->
      <!-- 새로만들기 -->
      <div v-if="!canDuplicate || createType === 'new'">
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.name}}</div>
          <input
            type="text"
            class="input"
            v-model="name">
        </div>
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.admin_codelist}}</div>
          <select
            v-model="catCode"
            class="input select">
            <option
              v-for="(code, index) in catCodeList"
              :key="index"
              :value="code.id">
              {{ code.id === 'system_shop_service' ? locale.system_shop_service : code.label }}
            </option>
          </select>
        </div>
        <div v-if="shopCodeList.length > 0" class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.sync_data}}</div>
          <select class="input select" v-model="connectShop">
            <option value="">{{locale.no_sync}}</option>
            <option
              v-for="(item, index) in shopCodeList"
              :key="index"
              :value="item.shopCode">
              [{{ item.shopCode }}] {{ item.name }}
            </option>
          </select>
        </div>
        <div v-else-if="shopCodes.length === 1" class="colorRed"> <!-- 다른 페이지에서 이미 이 catCode에 shopCode 설정이 되어 있으면 UNKNOWN만 리턴됨 -->
          * {{ locale.message_disabled_sync_submit_code }}
        </div>
        <div v-if="connectShop">
          <span class="checkbox">
            <input type="checkbox" id="sync_category" v-model="syncCategory">
            <label for="sync_category">{{ locale.sync_category }}</label>
          </span>
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="setCreateType('')">{{ locale.cancel }}</button>
          <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="create">{{locale.do_create}}</button>
        </div>
      </div>
      <!-- //새로만들기 -->
      <!-- 샵 복제하기 -->
      <div v-if="createType === 'duplicate'" class="createDuplicate">
        <p class="duplicateMessage">{{ locale.message_select_shop_origin }}</p>
        <ul v-if="shopPageList" class="pageList">
          <li v-for="shop in shopPageList"
            :key="shop.pageId"
            :class="{isActive: duplicatePageId === shop.pageId, isBaseShopPos: shop.isBaseShopPos}"
            @click="setDuplicatePage(shop.pageId)">
            {{ shop.pageName }}
          </li>
        </ul>
        <div class="mt15">
          <div class="mb10">
            <div class="checkbox">
              <input type="checkbox" id="duplicate_shop_option" v-model="duplicateOption">
              <label for="duplicate_shop_option">{{ locale.duplicate_include_shop_option}}</label>
            </div>
          </div>
          <div class="checkbox">
            <input type="checkbox" id="duplicate_shop_category" v-model="duplicateCategory">
            <label for="duplicate_shop_category">{{ locale.duplicate_include_shop_category }}</label>
          </div>
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="setCreateType('')">{{ locale.cancel }}</button>
          <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="create">{{locale.do_create}}</button>
        </div>
      </div>
      <!-- //샵 복제하기 -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'

export default {
  name: 'CreateShop',
  props: [
    'locale',
    'canDuplicate'
  ],
  components: {
  },
  computed: {
    catCodeList () {
      return this.$store.getters['admin/shopCodeList']
    },
    shopCodeList () {
      return this.shopCodes.filter(x => x.shopCode)
    },
    isValid () {
      const createType = this.createType
      const isNew = !this.canDuplicate || createType === 'new'
      const name = this.name.length > 0
      const catCode = this.catCode.length > 0
      return isNew ? name && catCode : this.duplicatePageId
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  watch: {
    createType (type) {
      const isDuplicate = type === 'duplicate'
      if (isDuplicate) {
        this.getShopPageList()
      }
    },
    connectShop (shopCode) {
      if (shopCode) {
        const shopInfo = this.shopCodes.find(x => x.shopCode === shopCode)
        this.isBaseShopPos = true
        // this.name = shopInfo.name
        this.shopCode = shopInfo.shopCode
      } else {
        this.isBaseShopPos = false
        this.shopCode = ''
      }
    },
    catCode (catCode) {
      this.getConnectShopCodes()
    }
  },
  data () {
    return {
      createType: '',
      name: '',
      shopCode: null,
      catCode: '',
      isBaseShopPos: false,
      connectShop: '',
      shopCodes: [],
      syncCategory: false,
      shopPageList: [],
      duplicateCategory: true,
      duplicateOption: true,
      duplicatePageId: ''
    }
  },
  methods: {
    setCreateType (type) {
      this.createType = type
    },
    setDuplicatePage (pageId) {
      if (this.duplicatePageId === pageId) {
        this.duplicatePageId = ''
        return
      }
      this.duplicatePageId = pageId
    },
    async getShopPageList () {
      this.$store.commit('onLoading', true)
      const shopList = await this.$store.dispatch('shop/getShopPageList')
      const pageList = shopList && shopList.message && shopList.message.pageList
      if (pageList) {
        this.shopPageList = pageList
      }
      this.$store.commit('onLoading', false)
    },
    async init () {
      // this.getConnectShopCodes()
    },
    async getConnectShopCodes () {
      this.$store.commit('onLoading', true)
      const catCode = this.catCode
      const connectShopList = await this.$store.dispatch('shop/getConnectShopCodes', catCode)
      const shopCodes = connectShopList && connectShopList.message && connectShopList.message.shopCodes
      if (shopCodes) {
        this.shopCodes = shopCodes
      }
      this.$store.commit('onLoading', false)
    },
    create () {
      if (this.createType === 'duplicate') {
        const pageId = this.duplicatePageId
        const getPageName = this.shopPageList.find(page => page.pageId === pageId)?.pageName
        const data = {
          pageName: `${getPageName} copy`,
          targetPageId: pageId,
          includeCategory: this.duplicateCategory,
          includeOption: this.duplicateOption
        }
        this.$emit('duplicate', data)
        return
      }
      const data = {
        pageName: this.name,
        catCode: this.catCode,
        isBaseShopPos: this.isBaseShopPos,
        ...this.isBaseShopPos && {
          connShopPos: {
            shopCode: this.shopCode,
            syncCategory: this.syncCategory
          }
        }
      }
      this.$emit('create', data)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner:not([data-duplicate]) {
    max-width: 400px;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
.createDuplicate {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.duplicateMessage {
  margin-bottom: 8px;
  font-size: 14px;
}
.pageList {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  overflow: auto;
  font-size: 14px;
  li {
    min-height: calc(24px + 4.5em);
    padding: 12px 16px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background-color: $color-white;
    cursor: pointer;
    &:hover {
      border-color: $color-lgrey;
    }
  }
  li.isActive {
    color: $color-primary;
    border-color: $color-primary;
  }
  .isBaseShopPos {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: 4px;
      left: 4px;
      width: 12px;
      height: 12px;
      background: url('~@/assets/img/link-2.png') 50% 50% / contain no-repeat;
      opacity: 0.4;
    }
  }
}
.createBtns {
  display: flex;
  gap: 12px;
  height: 140px;
  margin-top: 15px;
}
.btnCreate {
  flex: 1;
  font-size: 16px;
  border: 1px solid $color-lgrey2;
  border-radius: 12px;
  background-color: $color-white;
  &:hover {
    border-color: $color-lgrey;
  }
  &:before {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 auto 12px;
    opacity: 0.2;
  }
  &.btnDup:before {
    background: url('~@/assets/img/ico_copy_black.svg') 50% 50% / contain no-repeat;
  }
  &.btnNew:before {
    border: 2px dashed $color-dark;
    border-radius: 4px;
  }
}
</style>
